import React, { useCallback, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink, useMatch, useNavigate } from 'react-router-dom';
import { Rhombus } from 'mdi-material-ui';
import StyledMainMenuNestedButton from 'common/theme/menu/StyledMainMenuNestedButton';
import StyledMainMenuNestedLink from 'common/theme/menu/StyledMainMenuNestedLink';
import StyledMainMenuNestedListItemIcon from 'common/theme/menu/StyledMainMenuNestedListItemIcon';
import StyledMainMenuNestedListItemText from 'common/theme/menu/StyledMainMenuNestedListItemText';
import SidebarPanelContext, { matchesSearchQuery } from 'context/SidebarPanelContext';


function NestedMenuItem({ label, path, end = true, forceVisible = false }) {
  const { isMobile, onNavigate, query, registerItem, unregisterItem } = useContext(SidebarPanelContext);
  const navigate = useNavigate();

  // Mismo orden que en MenuItem: en móvil se cierra el panel ANTES de navegar, o la animación de
  // cierre compite con el render de la pantalla nueva y el panel se queda a medio recoger.
  const handleClick = useCallback(
    (event) => {
      if (!isMobile) {
        onNavigate();
        return;
      }
      event.preventDefault();
      // Encadenado al aviso real de cierre del panel, no a un plazo fijo (ver MenuItem).
      onNavigate(() => navigate(path));
    },
    [isMobile, onNavigate, navigate, path]
  );
  // Activo por URL (antes solo pintaba el ícono vía la clase .active del NavLink).
  const match = useMatch(end ? path : `${path}/*`);
  const isActive = match !== null;

  // Visible si no hay filtro, si su label matchea, o si el título del grupo padre matchea.
  const visible = forceVisible || matchesSearchQuery(label, query);

  useEffect(() => {
    registerItem(path, { label, path });
    return () => unregisterItem(path);
  }, [label, path, registerItem, unregisterItem]);

  if (!visible) return null;

  return (
    <StyledMainMenuNestedLink component={NavLink} to={path} end={end} onClick={handleClick}>
      <StyledMainMenuNestedButton selected={isActive}>
        <StyledMainMenuNestedListItemIcon>
          <Rhombus />
        </StyledMainMenuNestedListItemIcon>
        <StyledMainMenuNestedListItemText primary={label} />
      </StyledMainMenuNestedButton>
    </StyledMainMenuNestedLink>
  );
}

NestedMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  end: PropTypes.bool,
  forceVisible: PropTypes.bool
};

export default NestedMenuItem;
